import { render } from "./StudentDailyChallengesView.vue?vue&type=template&id=497f4c4a"
import script from "./StudentDailyChallengesView.vue?vue&type=script&lang=js"
export * from "./StudentDailyChallengesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__